// extracted by mini-css-extract-plugin
export var menuItem = "w_tL d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "w_tM d_Z d_bz d_bP";
export var menuMainLink = "w_tN d_f0 d_dB";
export var menuLink = "w_tP d_f0 d_dB";
export var icon = "w_p9 d_bC d_bP";
export var divider = "w_tQ d_bC d_bP";
export var sublinks = "w_tR";
export var link = "w_mC";
export var Link = "w_rM q_rM q_qZ q_rj";